import React, { useState, useEffect, useRef } from 'react';
import { Building2, Heart, Shield, Users, Home, Sparkles } from 'lucide-react';

const Highlights = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const highlights = [
    { icon: Building2, text: "A sprawling gated community in Thamarasserry" },
    { icon: Home, text: "One bed room and two bed room villa options" },
    { icon: Heart, text: "Full Fledged Wellness Centre" },
    { icon: Users, text: "Club House with well equipped kitchen and entertainment facilities" },
    { icon: Sparkles, text: "Ample Open recreation space" },
    { icon: Shield, text: "Personalized care plans" },
    { icon: Heart, text: "Warm and welcoming community" },
    { icon: Home, text: "Independence and homily living" }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>      
      <div ref={sectionRef} className="pt-24 sm:pt-32 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          
          {/* Header with decorative elements */}
          <div className="text-center mb-16 sm:mb-20 relative">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-red-100 rounded-full blur-3xl opacity-30"></div>
            <h2 className="text-3xl md:text-4xl text-[var(--primarycolor)] tracking-tight mb-4">
              What Makes Us Special
            </h2>
            {/* <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">Discover the exceptional features that set us apart</p> */}
          </div>

          {/* Card Grid with depth */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {highlights.map((highlight, index) => {
              const Icon = highlight.icon;
              
              return (
                <div 
                  key={index} 
                  className={`group relative rounded-2xl p-6 bg-gradient-to-br from-red-50 via-rose-50 to-white border border-red-100 overflow-hidden ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                  style={{ 
                    transitionDelay: `${index * 100}ms`,
                    // background: 'linear-gradient(135deg, #ffffff 0%, #fff5f5 100%)'
                  }}
                >
                  
                  {/* Decorative corner accent */}
                  <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-red-500/15 via-red-500/10 to-transparent rounded-bl-full"></div>
                  
                  {/* Icon with gradient background */}
                  <div className="relative mb-4">
                    <div className="w-12 h-12 rounded-xl mx-auto flex items-center justify-center bg-[var(--primarycolor)] group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <div className="absolute inset-0 w-16 h-16 rounded-2xl mx-auto bg-gradient-to-br from-[var(--primarycolor)] to-rose-800 blur-xl opacity-30 group-hover:opacity-50 transition-opacity"></div>
                  </div>

                  {/* Text content */}
                  <p className="text-gray-700 leading-relaxed text-center min-h-[3rem] flex items-center justify-center">
                    {highlight.text}
                  </p>
                  
                  {/* Bottom accent line */}
                  <div className="absolute bottom-0 left-1/2 w-0 -translate-x-1/2 h-1 bg-gradient-to-r from-red-600 to-rose-700 group-hover:w-3/4 transition-all duration-300 rounded-full"></div>
                  
                </div>
              );
            })}
          </div>

          {/* Bottom decorative element */}
          {/* <div className="text-center mt-20 relative">
            <div className="flex items-center justify-center gap-2">
              <div className="w-12 h-px bg-gradient-to-r from-transparent to-red-300"></div>
              <div className="w-2 h-2 rounded-full bg-red-600"></div>
              <div className="w-12 h-px bg-gradient-to-l from-transparent to-red-300"></div>
            </div>
          </div> */}
          
        </div>
      </div>
    </>
  );
};

export default Highlights;